import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import { TextbausteinListResource, TextbausteinResource } from './textbaustein.model';
import { TextbausteineListLinkRel } from './textbaustein.linkrel';
import {
	loadTextbausteine,
	loadTextbausteineSuccess,
	resetEditedText,
	updateTextbausteinSuccess,
} from './textbaustein.actions';
import { getEmbeddedResource } from '@ngxp/rest';
import { isNil, isNull } from 'lodash-es';
import { sameUri } from '@schir-int-client/tech';
import { initialState, TextbausteinRootState, TextbausteinState } from './textbaustein.state';
import { createStateResource } from '@schir-int-client/ngrx-helpers';
import { InjectionToken } from '@angular/core';

export const textbausteinReducerInjectionToken = new InjectionToken<ActionReducerMap<TextbausteinRootState>>(
	'Registered TextbausteinReducer'
);

export function getTextbausteinReducer(): ActionReducerMap<TextbausteinRootState> {
	return {
		textbausteinRoot: textbausteineReducer,
	};
}

export const textbausteineReducer = createReducer(
	initialState,
	on(loadTextbausteine, (state: TextbausteinState): TextbausteinState => ({
		textbausteine: { ...state.textbausteine, loading: true },
	})),
	on(loadTextbausteineSuccess, (_, { payload }): TextbausteinState => ({
		textbausteine: createStateResource(toMap(payload)),
	})),
	on(resetEditedText, (state: TextbausteinState): TextbausteinState => {
		if (!state.textbausteine?.resource) {
			return state;
		}
		const textbausteine: { [targetColumn: string]: TextbausteinResource[] } = {};
		const currenTextbausteine = state.textbausteine.resource;
		if (currenTextbausteine) {
			//ETL hat (noch) keine Textbausteine
			Object.entries(currenTextbausteine).forEach(([key, value]) => {
				textbausteine[key] = value.map(v => ({ ...v, editedText: null }));
			});
		}

		return {
			textbausteine: createStateResource(textbausteine),
		};
	}),
	on(updateTextbausteinSuccess, (state: TextbausteinState, { textbaustein }): TextbausteinState => ({
		textbausteine: createStateResource(buildNewTextbausteinMap(state.textbausteine.resource, textbaustein)),
	}))
);

function toMap(listResource: TextbausteinListResource): { [targetColumn: string]: TextbausteinResource[] } {
	const textbausteine = <TextbausteinResource[]>(
		getEmbeddedResource(listResource, TextbausteineListLinkRel.TEXTBAUSTEINE_LIST)
	);
	if (isNull(textbausteine)) {
		return {};
	}
	let result: { [targetColumn: string]: TextbausteinResource[] } = {};

	textbausteine.forEach(baustein => {
		if (isNil(result[baustein.targetColumn])) {
			result = { ...result, [baustein.targetColumn]: [baustein] };
		} else {
			result[baustein.targetColumn].push(baustein);
		}
	});
	return result;
}

function buildNewTextbausteinMap(
	origMap: { [targetColumn: string]: TextbausteinResource[] },
	toReplace: TextbausteinResource
): { [targetColumn: string]: TextbausteinResource[] } {
	const result: { [targetColumn: string]: TextbausteinResource[] } = {};

	Object.keys(origMap).forEach(targetCol => {
		result[targetCol] = origMap[targetCol].map(baustein => (sameUri(baustein, toReplace) ? toReplace : baustein));
	});

	return result;
}
